import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Reset icons for the student-progress tab, modeled on the hand-drawn
 * sketch (docs/… / ~/Downloads/reset-icons-sketch.png):
 *
 *   ResetGradeIcon  — graduation cap  + bottom-left undo badge
 *   ResetLessonIcon — open book       + bottom-left undo badge
 *   ResetExamIcon   — document w/ ✓   + bottom-left undo badge
 *
 * Stroke-based line icons, strokeWidth 1.8, stroke="currentColor" so the
 * surrounding Button's color (muted gray at rest, danger-red on hover)
 * flows into every path. The badge circle uses `fill="white"` so it reads
 * as a distinct ring hanging off the main glyph, not as a hole punched
 * into it; everything else is `fill="none"`. Sized via `width/height=1em`
 * so AntD Button's `size="small"` controls them.
 *
 * Shapes are kept deliberately simple — these need to be legible at
 * 16-18px, not pretty at 48px.
 */
import React from 'react';
const COMMON_PROPS = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};
/** Small undo badge rendered at the bottom-left of each icon. Pulled out
 *  so all three icons share the exact same badge composition. */
function UndoBadge() {
    return (_jsxs(_Fragment, { children: [_jsx("circle", { cx: "4.5", cy: "19.5", r: "3.8", fill: "#FFFFFF" }), _jsx("path", { d: "M6.3 20.1 A 1.9 1.9 0 1 1 2.9 18.3" }), _jsx("path", { d: "M1.8 18.3 L2.9 18.3 L2.9 19.4" })] }));
}
export function ResetGradeIcon(props) {
    return (_jsxs("svg", { ...COMMON_PROPS, ...props, children: [_jsx("path", { d: "M12 3 L22 7.5 L12 12 L2 7.5 Z" }), _jsx("path", { d: "M6.8 9.6 L6.8 13 C 6.8 15 9.1 15.8 12 15.8 C 14.9 15.8 17.2 15 17.2 13 L 17.2 9.6" }), _jsx(UndoBadge, {})] }));
}
export function ResetLessonIcon(props) {
    return (_jsxs("svg", { ...COMMON_PROPS, ...props, children: [_jsx("path", { d: "M3 4 H 10 Q 12 4 12 6 V 17 Q 12 15 10 15 H 3 Z" }), _jsx("path", { d: "M21 4 H 14 Q 12 4 12 6 V 17 Q 12 15 14 15 H 21 Z" }), _jsx(UndoBadge, {})] }));
}
export function ResetExamIcon(props) {
    return (_jsxs("svg", { ...COMMON_PROPS, ...props, children: [_jsx("rect", { x: "5", y: "3", width: "14", height: "17", rx: "2", ry: "2" }), _jsx("path", { d: "M8 9.5 L10 11.5 L13.5 7.8" }), _jsx("path", { d: "M8 14 L15.5 14" }), _jsx("path", { d: "M8 17 L13 17" }), _jsx(UndoBadge, {})] }));
}
